<script lang="ts">
	import type { ComponentType } from '$lib/types/props';
	import DynamicComponent from '$lib/components/DynamicComponent.svelte';

	export let components: ComponentType[];
</script>

<div class="w-full grid grid-cols-1 gap-4 md:grid-cols-{components.length}">
	{#each components as c, index}
		<div>
			<DynamicComponent component={c} />
		</div>
	{/each}
</div>
